module.exports = __webpack_public_path__ + "img/900m.51a31d6d.png";